import { useCallback, useRef, useState } from 'react';
import WindyMap from '../../components/Map/WindyMap';
import { REGION_BOUNDS } from '../../data/regions';

import './YourAir.scss';

const YourAir = () => {
  const mapRef = useRef(null);

  const [highlightedRegion, setHighlightedRegion] = useState(null);

  const focusRegion = useCallback((key) => {
    const map = mapRef.current;
    if (!map) return;

    const bounds = REGION_BOUNDS[key];
    if (bounds) {
      setHighlightedRegion(key);
      map.flyToBounds(bounds, {
        padding: [24, 24],
        duration: 0.8,
        maxZoom: 5,
      });
    }
  }, []);

  return (
    <div className="container">
      <div className="col-4">
        <div className="content">
          <h1>Air Quality by Region</h1>
          <p>
            Each region has different elements that impact the air you breathe at home. Find out what's affecting the
            air quality where you live.
          </p>
          <h2>Click below or use the map to select your region:</h2>
          <ul className="region-list">
            {['NORTHEAST', 'SOUTHEAST', 'MIDWEST', 'ROCKIES', 'NORTHWEST', 'SOUTHWEST'].map((key) => (
              <li key={key}>
                <button type="button" className={key} aria-label={key.toLowerCase()} onClick={() => focusRegion(key)}>
                  {key.charAt(0) + key.slice(1).toLowerCase()}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="col-8">
        <WindyMap mapRef={mapRef} highlightedRegion={highlightedRegion} setHighlightedRegion={setHighlightedRegion} />
      </div>
    </div>
  );
};

export default YourAir;
